import api from "../../utils/api/api.utils";
export var reportProblem = function (data) {
    return api.post("/problems/report", { data: data });
};
export var reportProblemAddAttachment = function (reportId, data) {
    return api.post("/problems/report/".concat(reportId, "/attachment"), {
        data: data,
    });
};
